var map = {
	"./One.png": "e024",
	"./TECNO.png": "fa69",
	"./aegon.png": "36f9",
	"./alcatel.png": "89c4",
	"./apple.png": "9149",
	"./asus.png": "ba9c",
	"./b2x-company.png": "68a4",
	"./blaupunkt.png": "01cc",
	"./bullitt_group.png": "eef5",
	"./bullitt_group.png,bak": "cff0",
	"./cat.png": "72d1",
	"./chubb.png": "31ae",
	"./colonnade.png": "a1df",
	"./d_link.png": "6b80",
	"./evolveo.png": "8dfb",
	"./exim.png": "8464",
	"./go_pro.png": "b6e2",
	"./google.png": "024e",
	"./gsmart.png": "333a",
	"./honor.png": "0ac0",
	"./htc.png": "435a",
	"./huawei.png": "7598",
	"./hvs.png": "b413",
	"./iRobot.png": "f8f1",
	"./image003.jpg": "7099",
	"./infinix.png": "3fe5",
	"./kodak.png": "8bd5",
	"./land_rover.png": "44bd",
	"./lenovo_black.png": "c726",
	"./lg.png": "7b7d",
	"./mkb.png": "3bcf",
	"./mvm.png": "73cc",
	"./navon.png": "5fc1",
	"./okai.png": "ad77",
	"./one_plus.png": "0c2a",
	"./oppo.png": "e672",
	"./provident.png": "6a6f",
	"./realme.png": "664f",
	"./reverse-logistics.png": "8f1f",
	"./roborock.png": "309e",
	"./samsung.png": "6ff8",
	"./tcl.png": "87c1",
	"./telekom-white.png": "0a2b",
	"./telekom.png": "cf44",
	"./telenor-white.png": "0c5c",
	"./telenor.png": "fac1",
	"./tesla-silver.png": "fe2b",
	"./tesla.png": "0395",
	"./tmx-negyzet.png": "f328",
	"./triglav.png": "8bca",
	"./vivo.png": "d995",
	"./vodafone-white.png": "9c8a",
	"./vodafone.png": "68f0",
	"./xiaomi.png": "ff04",
	"./xiaomi2021.png": "ce80",
	"./yettelKEK640.png": "a7459"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6fcd";